<template>
  <div class="min-h-screen bg-white flex flex-col justify-center items-center px-4 py-12"
    style="font-family: 'Poppins', sans-serif;">
    <div class="w-full max-w-xl bg-white p-8  flex flex-col items-center text-center">


      <!-- Title & Description -->
      <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight mb-2">
        ¡Acreditación Exitosa!
      </h1>
      <p class="text-gray-600 mb-8 max-w-sm">
        Tu credencial ha sido generada correctamente. Podés descargarla a continuación.
      </p>


      <div class="w-full flex flex-col sm:flex-row gap-4 justify-center items-center">
        <a v-if="hash" @click="downloadCredencial" :href="downloadUrl" download id="btn-download-credencial"
          class="w-full sm:w-auto inline-flex justify-center items-center px-8 py-3.5 bg-[#ec1c24] border border-[#ec1c24] text-white hover:bg-white hover:text-[#ec1c24] font-semibold rounded-xl transition duration-200 shadow-md cursor-pointer hover:shadow-lg transform active:scale-95">
          <i class="pi pi-download mr-2 text-lg"></i> Descargar Credencial
        </a>
      </div>




    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AcreditacionFinalizada',
  methods: {
    downloadCredencial() {
      window.parent.postMessage('pase_descargado', '*');
      console.log("POST MESSAGE: pase_descargado");
    }
  },
  computed: {
    hash(): string {
      return (this.$route.params.hash as string) || '';
    },

    downloadUrl(): string {
      window.parent.postMessage('pase_descargado', '*');
      console.log("POST MESSAGE: pase_descargado");

      return `https://apps.qreventos.com/credencial/getCredencial?credencial=647&evento=865&hash=${this.hash}`;
    }
  },

});
</script>
